import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { V3_APP_BASE_URL } from '@/constants/Config';
import type { IQuoteResponse, QuoterPayload } from '@/common/interfaces/quoter.interface';

/**  Endpoint to fetch quote.  */
export const fetchQuoterApi = createApi({
  reducerPath: 'fetchQuoterApi',
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    getQuote: builder.mutation<IQuoteResponse[], { data: QuoterPayload }>({
      query: ({ data }) => ({
        url: 'api/v4/new-quoter?stockLevelsOnly=false&isHQ=true',
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const { useGetQuoteMutation } = fetchQuoterApi;
